import {
  Component,
  OnInit,
  NgZone,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ServicesService } from "../../services/services.service";
import swal from "sweetalert2";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { MapsAPILoader } from "@agm/core";
import { EmployeeModalComponent } from "../../employee-modal/employee-modal.component";

@Component({
  selector: "app-create-maintenance",
  templateUrl: "./create-maintenance.component.html",
  styleUrls: ["./create-maintenance.component.css"],
})
export class CreateMaintenanceComponent implements OnInit {
  @ViewChild("content") content: any; // ViewChild decorator for accessing modal template
  @ViewChild("employeeModal") employeeModal: any;
  // @ViewChild("employeeInput") employeeInput: any;
  // @ViewChild("employeeInput") employeeInput!: ElementRef;
  filteredEmployees: any[];
  searchQuery: string;
  selectedEmployee: any;
  employees: any[];
  allEmployees: any[] = [];

  public routePath;

  addMaintenanceOrderForm: FormGroup;
  isFormSubmitted = false;
  showloader = false;
  employeeList = [];
  keyword: any;

  constructor(
    private formBuilder: FormBuilder,
    private _services: ServicesService,
    private router: Router,
    private ngZone: NgZone,
    private modalService: NgbModal,
    private mapsAPILoader: MapsAPILoader
  ) {}

  mapTitle: string;
  closeResult: string;
  mapFor: string;

  /*-----------------------------------Model pop up-----------------------------*/

  open(content, event) {
    this.modalService.open(content).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
    this.mapTitle = "Select your area";

    /*-----------------Get clicked element---------------*/
    var target = event.target || event.srcElement || event.currentTarget;
    var idAttr = target.attributes.id;
    var value = idAttr.nodeValue;
    // //console.log(this.addMaintenanceOrderForm.controls.address.value);
    this.routeLocation = this.addMaintenanceOrderForm.controls.address.value;

    // this.routeLocation = this.deliveryDetails['delivery-address'];
    this.mapFor = value;
    this.requestedMap =
      this.mapFor == "delivery-address-map" ? "delivery-address" : "source";
    //console.log("requestedMap",this.requestedMap);

    //console.log(this.routeLocation);
    this.geoCodeAddress(this.routeLocation);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  /*-----------------------------------Model pop up-----------------------------*/

  @ViewChild("search")
  public searchElementRef: ElementRef;
  /*----------------------------------Google API--------------------------------*/
  deliveryDetails: Object = {};
  routeLocation: string;
  public latitude: number;
  public longitude: number;
  public zoom: number;
  public formatted_address: string;
  public dataToSend: Object = {};
  requestedMap: string;
  public data: string[] = [
    "Buffalo City Metropolitan Municipality",
    "Eastern Cape",
    "East London",
    "City of Cape Town Metropolitan Municipality",
    "Western Cape",
    "Cape Town",
    "City of Johannesburg Metropolitan Municipality",
    "Gauteng",
    "Johannesburg",
    "City of Tshwane Metropolitan Municipality",
    "Gauteng",
    "Pretoria",
    "Ekurhuleni Metropolitan Municipality",
    "Gauteng",
    "Germiston",
    "eThekwini Metropolitan Municipality",
    "KwaZulu-Natal",
    "Durban",
    "Mangaung Metropolitan Municipality",
    "Free State",
    "Bloemfontein",
    "Nelson Mandela Bay Metropolitan Municipality",
    "Eastern Cape",
    "Port Elizabeth",
    "Alfred Nzo District Municipality",
    "Eastern Cape",
    "Mount Ayliff",
    "Amajuba District Municipality",
    "KwaZulu-Natal",
    "Newcastle",
    "Amathole District Municipality",
    "Eastern Cape",
    "East London",
    "Bojanala District Municipality",
    "North West",
    "Rustenburg",
    "Buffalo City Metropolitan Municipality",
    "Eastern Cape",
    "East London",
    "Cape Winelands District Municipality",
    "Western Cape",
    "Worcester",
    "Capricorn District Municipality",
    "Limpopo",
    "Polokwane",
    "Central Karoo District Municipality",
    "Western Cape",
    "Beaufort West",
    "Chris Hani District Municipality",
    "Eastern Cape",
    "Queenstown",
    "City of Cape Town Metropolitan Municipality",
    "Western Cape",
    "Cape Town",
    "City of Johannesburg Metropolitan Municipality",
    "Gauteng",
    "Johannesburg",
    "City of Tshwane Metropolitan Municipality",
    "Gauteng",
    "Pretoria",
    "Dr Kenneth Kaunda District Municipality",
    "North West",
    "Klerksdorp",
    "Dr Ruth Segomotsi Mompati District Municipality",
    "North West",
    "Vryburg",
    "Ehlanzeni District Municipality",
    "Mpumalanga",
    "Nelspruit",
    "Ekurhuleni Metropolitan Municipality",
    "Gauteng",
    "Germiston",
    "eThekwini Metropolitan Municipality",
    "KwaZulu-Natal",
    "Durban",
    "Fezile Dabi District Municipality",
    "Free State",
    "Sasolburg",
    "Frances Baard District Municipality",
    "Northern Cape",
    "Kimberley",
    "Garden Route District Municipality",
    "Western Cape",
    "George",
    "Gert Sibande District Municipality",
    "Mpumalanga",
    "Ermelo",
    "Harry Gwala District Municipality",
    "KwaZulu-Natal",
    "Ixopo",
    "iLembe District Municipality",
    "KwaZulu-Natal",
    "KwaDukuza",
    "Joe Gqabi District Municipality",
    "Eastern Cape",
    "Barkly East",
    "John Taolo Gaetsewe District Municipality",
    "Northern Cape",
    "Kuruman",
    "King Cetshwayo District Municipality",
    "KwaZulu-Natal",
    "Richards Bay",
    "Lejweleputswa District Municipality",
    "Free State",
    "Welkom",
    "Mangaung Metropolitan Municipality",
    "Free State",
    "Bloemfontein",
    "Mopani District Municipality",
    "Limpopo",
    "Giyani",
    "Namakwa District Municipality",
    "Northern Cape",
    "Springbok",
    "Nelson Mandela Bay Metropolitan Municipality",
    "Eastern Cape",
    "Port Elizabeth",
    "Ngaka Modiri Molema District Municipality",
    "North West",
    "Mahikeng",
    "Nkangala District Municipality",
    "Mpumalanga",
    "Middelburg",
    "OR Tambo District Municipality",
    "Eastern Cape",
    "Mthatha",
    "Overberg District Municipality",
    "Western Cape",
    "Bredasdorp",
    "Pixley ka Seme District Municipality",
    "Northern Cape",
    "De Aar",
    "Sarah Baartman District Municipality",
    "Eastern Cape",
    "Port Elizabeth",
    "Sedibeng District Municipality",
    "Gauteng",
    "Vereeniging",
    "Sekhukhune District Municipality",
    "Limpopo",
    "Groblersdal",
    "Thabo Mofutsanyana District Municipality",
    "Free State",
    "Phuthaditjhaba",
    "Ugu District Municipality",
    "KwaZulu-Natal",
    "Port Shepstone",
    "uMgungundlovu District Municipality",
    "KwaZulu-Natal",
    "Pietermaritzburg",
    "uMkhanyakude District Municipality",
    "KwaZulu-Natal",
    "Mkuze",
    "uMzinyathi District Municipality",
    "KwaZulu-Natal",
    "Dundee",
    "uThukela District Municipality",
    "KwaZulu-Natal",
    "Ladysmith",
    "Vhembe District Municipality",
    "Limpopo",
    "Thohoyandou",
    "Waterberg District Municipality",
    "Limpopo",
    "Modimolle",
    "West Coast District Municipality",
    "Western Cape",
    "Moorreesburg",
    "West Rand District Municipality",
    "Gauteng",
    "Randfontein",
    "Xhariep District Municipality",
    "Free State",
    "Trompsburg",
    "ZF Mgcawu District Municipality",
    "Northern Cape",
    "Upington",
    "Zululand District Municipality",
    "KwaZulu-Natal",
    "Ulundi",
    "Abaqulusi Local Municipality",
    "KwaZulu-Natal",
    "Zululand",
    "Vryheid",
    "Albert Luthuli Local Municipality",
    "Mpumalanga",
    "Gert Sibande",
    "Carolina",
    "Alfred Duma Local Municipality",
    "KwaZulu-Natal",
    "Uthukela",
    "Ladysmith",
    "Amahlathi Local Municipality",
    "Eastern Cape",
    "Amathole",
    "Stutterheim",
    "Ba-Phalaborwa Local Municipality",
    "Limpopo",
    "Mopani",
    "Phalaborwa",
    "Beaufort West Local Municipality",
    "Western Cape",
    "Central Karoo",
    "Beaufort West",
    "Bela-Bela Local Municipality",
    "Limpopo",
    "Waterberg",
    "Bela-Bela",
    "Bergrivier Local Municipality",
    "Western Cape",
    "West Coast",
    "Piketberg",
    "Big Five Hlabisa Local Municipality",
    "KwaZulu-Natal",
    "Umkhanyakude",
    "Hlabisa",
    "Bitou Local Municipality",
    "Western Cape",
    "Garden Route",
    "Plettenberg Bay",
    "Blouberg Local Municipality",
    "Limpopo",
    "Capricorn",
    "Senwabarwana",
    "Blue Crane Route Local Municipality",
    "Eastern Cape",
    "Sarah Baartman",
    "Somerset East",
    "Breede Valley Local Municipality",
    "Western Cape",
    "Cape Winelands",
    "Worcester",
    "Buffalo City Metropolitan Municipality",
    "Eastern Cape",
    "East London",
    "Bushbuckridge Local Municipality",
    "Mpumalanga",
    "Ehlanzeni",
    "Bushbuckridge",
    "Cape Agulhas Local Municipality",
    "Western Cape",
    "Overberg",
    "Bredasdorp",
    "Cederberg Local Municipality",
    "Western Cape",
    "West Coast",
    "Clanwilliam",
    "City of Cape Town Metropolitan Municipality",
    "Western Cape",
    "Cape Town",
    "City of Johannesburg Metropolitan Municipality",
    "Gauteng",
    "Johannesburg",
    "City of Matlosana Local Municipality",
    "North West",
    "Dr Kenneth Kaunda",
    "Klerksdorp",
    "City of Tshwane Metropolitan Municipality",
    "Gauteng",
    "Pretoria",
    "Collins Chabane Local Municipality",
    "Limpopo",
    "Vhembe",
    "Malamulele",
    "Dannhauser Local Municipality",
    "KwaZulu-Natal",
    "Amajuba",
    "Dannhauser",
    "Dawid Kruiper Local Municipality",
    "Northern Cape",
    "ZF Mgcawu",
    "Upington",
    "Dihlabeng Local Municipality",
    "Free State",
    "Thabo Mofutsanyana",
    "Bethlehem",
    "Dikgatlong Local Municipality",
    "Northern Cape",
    "Frances Baard",
    "Barkly West",
    "Dipaleseng Local Municipality",
    "Mpumalanga",
    "Gert Sibande",
    "Balfour",
    "Ditsobotla Local Municipality",
    "North West",
    "Ngaka Modiri Molema",
    "Lichtenburg",
    "Dr Beyers Naudé Local Municipality",
    "Eastern Cape",
    "Sarah Baartman",
    "Graaff-Reinet",
    "Dr JS Moroka Local Municipality",
    "Mpumalanga",
    "Nkangala",
    "Siyabuswa",
    "Dr Nkosazana Dlamini Zuma Local Municipality",
    "KwaZulu-Natal",
    "Harry Gwala",
    "Creighton",
    "Drakenstein Local Municipality",
    "Western Cape",
    "Cape Winelands",
    "Paarl",
    "eDumbe Local Municipality",
    "KwaZulu-Natal",
    "Zululand",
    "Paulpietersburg",
    "Ekurhuleni Metropolitan Municipality",
    "Gauteng",
    "Germiston",
    "Elias Motsoaledi Local Municipality",
    "Limpopo",
    "Sekhukhune",
    "Groblersdal",
    "Elundini Local Municipality",
    "Eastern Cape",
    "Joe Gqabi",
    "Maclear",
    "eMadlangeni Local Municipality",
    "KwaZulu-Natal",
    "Amajuba",
    "Utrecht",
    "Emakhazeni Local Municipality",
    "Mpumalanga",
    "Nkangala",
    "Belfast",
    "Emalahleni Local Municipality",
    "Eastern Cape",
    "Chris Hani",
    "Lady Frere",
    "Emalahleni Local Municipality",
    "Mpumalanga",
    "Nkangala",
    "eMalahleni",
    "Emfuleni Local Municipality",
    "Gauteng",
    "Sedibeng",
    "Vanderbijlpark",
    "Emthanjeni Local Municipality",
    "Northern Cape",
    "Pixley ka Seme",
    "De Aar",
    "Endumeni Local Municipality",
    "KwaZulu-Natal",
    "Umzinyathi",
    "Dundee",
    "Engcobo Local Municipality",
    "Eastern Cape",
    "Chris Hani",
    "Ngcobo",
    "Enoch Mgijima Local Municipality",
    "Eastern Cape",
    "Chris Hani",
    "Queenstown",
    "Ephraim Mogale Local Municipality",
    "Limpopo",
    "Sekhukhune",
    "Marble Hall",
    "eThekwini Metropolitan Municipality",
    "KwaZulu-Natal",
    "Durban",
    "Fetakgomo/Greater Tubatse Local Municipality",
    "Limpopo",
    "Sekhukhune",
    "Apel",
    "Ga-Segonyana Local Municipality",
    "Northern Cape",
    "John Taolo Gaetsewe",
    "Kuruman",
    "Gamagara Local Municipality",
    "Northern Cape",
    "John Taolo Gaetsewe",
    "Kathu",
    "George Local Municipality",
    "Western Cape",
    "Garden Route",
    "George",
    "Govan Mbeki Local Municipality",
    "Mpumalanga",
    "Gert Sibande",
    "Secunda",
    "Great Kei Local Municipality",
    "Eastern Cape",
    "Amathole",
    "Komga",
    "Greater Giyani Local Municipality",
    "Limpopo",
    "Mopani",
    "Giyani",
    "Greater Kokstad Local Municipality",
    "KwaZulu-Natal",
    "Harry Gwala",
    "Kokstad",
    "Greater Letaba Local Municipality",
    "Limpopo",
    "Mopani",
    "Modjadjiskloof",
    "Greater Taung Local Municipality",
    "North West",
    "Dr Ruth Segomotsi Mompati",
    "Taung",
    "Greater Tzaneen Local Municipality",
    "Limpopo",
    "Mopani",
    "Tzaneen",
    "Hantam Local Municipality",
    "Northern Cape",
    "Namakwa",
    "Calvinia",
    "Hessequa Local Municipality",
    "Western Cape",
    "Garden Route",
    "Riversdale",
    "Impendle Local Municipality",
    "KwaZulu-Natal",
    "uMgungundlovu",
    "Impendle",
    "Ingquza Hill Local Municipality",
    "Eastern Cape",
    "OR Tambo",
    "Flagstaff",
    "Inkosi Langalibalele Local Municipality",
    "KwaZulu-Natal",
    "Uthukela",
    "Estcourt",
    "Intsika Yethu Local Municipality",
    "Eastern Cape",
    "Chris Hani",
    "Cofimvaba",
    "Inxuba Yethemba Local Municipality",
    "Eastern Cape",
    "Chris Hani",
    "Cradock",
    "JB Marks Local Municipality",
    "North West",
    "Dr Kenneth Kaunda",
    "Potchefstroom",
    "Joe Morolong Local Municipality",
    "Northern Cape",
    "John Taolo Gaetsewe",
    "Mothibistad",
    "Jozini Local Municipality",
    "KwaZulu-Natal",
    "Umkhanyakude",
    "Jozini",
    "Kagisano-Molopo Local Municipality",
    "North West",
    "Dr Ruth Segomotsi Mompati",
    "Ganyesa",
    "Kai !Garib Local Municipality",
    "Northern Cape",
    "ZF Mgcawu",
    "Kakamas",
    "Kamiesberg Local Municipality",
    "Northern Cape",
    "Namakwa",
    "Garies",
    "Kannaland Local Municipality",
    "Western Cape",
    "Garden Route",
    "Ladismith",
    "Kareeberg Local Municipality",
    "Northern Cape",
    "Pixley ka Seme",
    "Carnarvon",
    "Karoo Hoogland Local Municipality",
    "Northern Cape",
    "Namakwa",
    "Williston",
    "Kgatelopele Local Municipality",
    "Northern Cape",
    "ZF Mgcawu",
    "Daniëlskuil",
    "Kgetlengrivier Local Municipality",
    "North West",
    "Bojanala",
    "Koster",
    "Khâi-Ma Local Municipality",
    "Northern Cape",
    "Namakwa",
    "Pofadder",
    "!Kheis Local Municipality",
    "Northern Cape",
    "ZF Mgcawu",
    "Groblershoop",
    "King Sabata Dalindyebo Local Municipality",
    "Eastern Cape",
    "OR Tambo",
    "Mthatha",
    "Knysna Local Municipality",
    "Western Cape",
    "Garden Route",
    "Knysna",
    "Kopanong Local Municipality",
    "Free State",
    "Xhariep",
    "Trompsburg",
    "Kou-Kamma Local Municipality",
    "Eastern Cape",
    "Sarah Baartman",
    "Kareedouw",
    "Kouga Local Municipality",
    "Eastern Cape",
    "Sarah Baartman",
    "Jeffreys Bay",
    "KwaDukuza Local Municipality",
    "KwaZulu-Natal",
    "iLembe",
    "KwaDukuza",
    "Laingsburg Local Municipality",
    "Western Cape",
    "Central Karoo",
    "Laingsburg",
    "Langeberg Local Municipality",
    "Western Cape",
    "Cape Winelands",
    "Ashton",
    "Lekwa Local Municipality",
    "Mpumalanga",
    "Gert Sibande",
    "Standerton",
    "Lekwa-Teemane Local Municipality",
    "North West",
    "Dr Ruth Segomotsi Mompati",
    "Christiana",
    "Lepelle-Nkumpi Local Municipality",
    "Limpopo",
    "Capricorn",
    "Chuniespoort",
    "Lephalale Local Municipality",
    "Limpopo",
    "Waterberg",
    "Lephalale",
    "Lesedi Local Municipality",
    "Gauteng",
    "Sedibeng",
    "Heidelberg",
    "Letsemeng Local Municipality",
    "Free State",
    "Xhariep",
    "Koffiefontein",
    "Madibeng Local Municipality",
    "North West",
    "Bojanala",
    "Brits",
    "Mafube Local Municipality",
    "Free State",
    "Fezile Dabi",
    "Frankfort",
    "Magareng Local Municipality",
    "Northern Cape",
    "Frances Baard",
    "Warrenton",
    "Mahikeng Local Municipality",
    "North West",
    "Ngaka Modiri Molema",
    "Mahikeng",
    "Makana Local Municipality",
    "Eastern Cape",
    "Sarah Baartman",
    "Grahamstown",
    "Makhado Local Municipality",
    "Limpopo",
    "Vhembe",
    "Louis Trichardt",
    "Makhuduthamaga Local Municipality",
    "Limpopo",
    "Sekhukhune",
    "Jane Furse",
    "Maluti-a-Phofung Local Municipality",
    "Free State",
    "Thabo Mofutsanyana",
    "Phuthaditjhaba",
    "Mamusa Local Municipality",
    "North West",
    "Dr Ruth Segomotsi Mompati",
    "Schweizer-Reneke",
    "Mandeni Local Municipality",
    "KwaZulu-Natal",
    "iLembe",
    "Mandeni",
    "Mangaung Metropolitan Municipality",
    "Free State",
    "Bloemfontein",
    "Mantsopa Local Municipality",
    "Free State",
    "Thabo Mofutsanyana",
    "Ladybrand",
    "Maphumulo Local Municipality",
    "KwaZulu-Natal",
    "iLembe",
    "Maphumulo",
    "Maquassi Hills Local Municipality",
    "North West",
    "Dr Kenneth Kaunda",
    "Wolmaransstad",
    "Maruleng Local Municipality",
    "Limpopo",
    "Mopani",
    "Hoedspruit",
    "Masilonyana Local Municipality",
    "Free State",
    "Lejweleputswa",
    "Theunissen",
    "Matatiele Local Municipality",
    "Eastern Cape",
    "Alfred Nzo",
    "Matatiele",
    "Matjhabeng Local Municipality",
    "Free State",
    "Lejweleputswa",
    "Welkom",
    "Matzikama Local Municipality",
    "Western Cape",
    "West Coast",
    "Vredendal",
    "Mbhashe Local Municipality",
    "Eastern Cape",
    "Amathole",
    "Dutywa",
    "Mbizana Local Municipality",
    "Eastern Cape",
    "Alfred Nzo",
    "Bizana",
    "Mbombela Local Municipality",
    "Mpumalanga",
    "Ehlanzeni",
    "Nelspruit",
    "Merafong City Local Municipality",
    "Gauteng",
    "West Rand",
    "Carletonville",
    "Metsimaholo Local Municipality",
    "Free State",
    "Fezile Dabi",
    "Sasolburg",
    "Mhlontlo Local Municipality",
    "Eastern Cape",
    "OR Tambo",
    "Qumbu",
    "Midvaal Local Municipality",
    "Gauteng",
    "Sedibeng",
    "Meyerton",
    "Mkhambathini Local Municipality",
    "KwaZulu-Natal",
    "uMgungundlovu",
    "Camperdown",
    "Mkhondo Local Municipality",
    "Mpumalanga",
    "Gert Sibande",
    "Piet Retief",
    "Mnquma Local Municipality",
    "Eastern Cape",
    "Amathole",
    "Gcuwa",
    "Modimolle/Mookgophong Local Municipality",
    "Limpopo",
    "Waterberg",
    "Modimolle",
    "Mogalakwena Local Municipality",
    "Limpopo",
    "Waterberg",
    "Mokopane",
    "Mogale City Local Municipality",
    "Gauteng",
    "West Rand",
    "Krugersdorp",
    "Mohokare Local Municipality",
    "Free State",
    "Xhariep",
    "Zastron",
    "Molemole Local Municipality",
    "Limpopo",
    "Capricorn",
    "Dendron",
    "Moqhaka Local Municipality",
    "Free State",
    "Fezile Dabi",
    "Kroonstad",
    "Moretele Local Municipality",
    "North West",
    "Bojanala",
    "Makapanstad",
    "Moses Kotane Local Municipality",
    "North West",
    "Bojanala",
    "Mogwase",
    "Mossel Bay Local Municipality",
    "Western Cape",
    "Garden Route",
    "Mossel Bay",
    "Mpofana Local Municipality",
    "KwaZulu-Natal",
    "uMgungundlovu",
    "Mooi River",
    "Msinga Local Municipality",
    "KwaZulu-Natal",
    "Umzinyathi",
    "Tugela Ferry",
    "Msukaligwa Local Municipality",
    "Mpumalanga",
    "Gert Sibande",
    "Ermelo",
    "Msunduzi Local Municipality",
    "KwaZulu-Natal",
    "uMgungundlovu",
    "Pietermaritzburg",
    "Mthonjaneni Local Municipality",
    "KwaZulu-Natal",
    "King Cetshwayo",
    "Melmoth",
    "Mtubatuba Local Municipality",
    "KwaZulu-Natal",
    "Umkhanyakude",
    "Mtubatuba",
    "Musina Local Municipality",
    "Limpopo",
    "Vhembe",
    "Musina",
    "Nala Local Municipality",
    "Free State",
    "Lejweleputswa",
    "Bothaville",
    "Naledi Local Municipality",
    "North West",
    "Dr Ruth Segomotsi Mompati",
    "Vryburg",
    "Nama Khoi Local Municipality",
    "Northern Cape",
    "Namakwa",
    "Springbok",
    "Ndlambe Local Municipality",
    "Eastern Cape",
    "Sarah Baartman",
    "Port Alfred",
    "Ndwedwe Local Municipality",
    "KwaZulu-Natal",
    "iLembe",
    "Ndwedwe",
    "Nelson Mandela Bay Metropolitan Municipality",
    "Eastern Cape",
    "Port Elizabeth",
    "Newcastle Local Municipality",
    "KwaZulu-Natal",
    "Amajuba",
    "Newcastle",
    "Ngqushwa Local Municipality",
    "Eastern Cape",
    "Amathole",
    "Peddie",
    "Ngwathe Local Municipality",
    "Free State",
    "Fezile Dabi",
    "Parys",
    "Nkandla Local Municipality",
    "KwaZulu-Natal",
    "King Cetshwayo",
    "Nkandla",
    "Nketoana Local Municipality",
    "Free State",
    "Thabo Mofutsanyana",
    "Reitz",
    "Nkomazi Local Municipality",
    "Mpumalanga",
    "Ehlanzeni",
    "Malalane",
    "Nongoma Local Municipality",
    "KwaZulu-Natal",
    "Zululand",
    "Nongoma",
    "Nqutu Local Municipality",
    "KwaZulu-Natal",
    "Umzinyathi",
    "Nquthu",
    "Ntabankulu Local Municipality",
    "Eastern Cape",
    "Alfred Nzo",
    "Ntabankulu",
    "Nyandeni Local Municipality",
    "Eastern Cape",
    "OR Tambo",
    "Libode",
    "Okhahlamba Local Municipality",
    "KwaZulu-Natal",
    "Uthukela",
    "Bergville",
    "Oudtshoorn Local Municipality",
    "Western Cape",
    "Garden Route",
    "Oudtshoorn",
    "Overstrand Local Municipality",
    "Western Cape",
    "Overberg",
    "Hermanus",
    "Phokwane Local Municipality",
    "Northern Cape",
    "Frances Baard",
    "Hartswater",
    "Phumelela Local Municipality",
    "Free State",
    "Thabo Mofutsanyana",
    "Vrede",
    "Pixley ka Seme Local Municipality",
    "Mpumalanga",
    "Gert Sibande",
    "Volksrust",
    "Polokwane Local Municipality",
    "Limpopo",
    "Capricorn",
    "Polokwane",
    "Port St Johns Local Municipality",
    "Eastern Cape",
    "OR Tambo",
    "Port St Johns",
    "Prince Albert Local Municipality",
    "Western Cape",
    "Central Karoo",
    "Prince Albert",
    "Ramotshere Moiloa Local Municipality",
    "North West",
    "Ngaka Modiri Molema",
    "Zeerust",
    "Rand West City Local Municipality",
    "Gauteng",
    "West Rand",
    "Randfontein",
    "Ratlou Local Municipality",
    "North West",
    "Ngaka Modiri Molema",
    "Setlagole",
    "Ray Nkonyeni Local Municipality",
    "KwaZulu-Natal",
    "Ugu",
    "Port Shepstone",
    "Raymond Mhlaba Local Municipality",
    "Eastern Cape",
    "Amathole",
    "Alice",
    "Renosterberg Local Municipality",
    "Northern Cape",
    "Pixley ka Seme",
    "Petrusville",
    "Richmond Local Municipality",
    "KwaZulu-Natal",
    "uMgungundlovu",
    "Richmond",
    "Richtersveld Local Municipality",
    "Northern Cape",
    "Namakwa",
    "Port Nolloth",
    "Rustenburg Local Municipality",
    "North West",
    "Bojanala",
    "Rustenburg",
    "Sakhisizwe Local Municipality",
    "Eastern Cape",
    "Chris Hani",
    "Cala",
    "Saldanha Bay Local Municipality",
    "Western Cape",
    "West Coast",
    "Vredenburg",
    "Senqu Local Municipality",
    "Eastern Cape",
    "Joe Gqabi",
    "Lady Grey",
    "Setsoto Local Municipality",
    "Free State",
    "Thabo Mofutsanyana",
    "Ficksburg",
    "Siyancuma Local Municipality",
    "Northern Cape",
    "Pixley ka Seme",
    "Douglas",
    "Siyathemba Local Municipality",
    "Northern Cape",
    "Pixley ka Seme",
    "Prieska",
    "Sol Plaatje Local Municipality",
    "Northern Cape",
    "Frances Baard",
    "Kimberley",
    "Stellenbosch Local Municipality",
    "Western Cape",
    "Cape Winelands",
    "Stellenbosch",
    "Steve Tshwete Local Municipality",
    "Mpumalanga",
    "Nkangala",
    "Middelburg",
    "Sundays River Valley Local Municipality",
    "Eastern Cape",
    "Sarah Baartman",
    "Kirkwood",
    "Swartland Local Municipality",
    "Western Cape",
    "West Coast",
    "Malmesbury",
    "Swellendam Local Municipality",
    "Western Cape",
    "Overberg",
    "Swellendam",
    "Thaba Chweu Local Municipality",
    "Mpumalanga",
    "Ehlanzeni",
    "Lydenburg",
    "Thabazimbi Local Municipality",
    "Limpopo",
    "Waterberg",
    "Thabazimbi",
    "Theewaterskloof Local Municipality",
    "Western Cape",
    "Overberg",
    "Caledon",
    "Thembelihle Local Municipality",
    "Northern Cape",
    "Pixley ka Seme",
    "Hopetown",
    "Thembisile Hani Local Municipality",
    "Mpumalanga",
    "Nkangala",
    "eMpumalanga",
    "Thulamela Local Municipality",
    "Limpopo",
    "Vhembe",
    "Thohoyandou",
    "Tokologo Local Municipality",
    "Free State",
    "Lejweleputswa",
    "Boshof",
    "Tsantsabane Local Municipality",
    "Northern Cape",
    "ZF Mgcawu",
    "Postmasburg",
    "Tswaing Local Municipality",
    "North West",
    "Ngaka Modiri Molema",
    "Delareyville",
    "Tswelopele Local Municipality",
    "Free State",
    "Lejweleputswa",
    "Bultfontein",
    "Ubuhlebezwe Local Municipality",
    "KwaZulu-Natal",
    "Harry Gwala",
    "Ixopo",
    "Ubuntu Local Municipality",
    "Northern Cape",
    "Pixley ka Seme",
    "Victoria West",
    "Ulundi Local Municipality",
    "KwaZulu-Natal",
    "Zululand",
    "Ulundi",
    "Umdoni Local Municipality",
    "KwaZulu-Natal",
    "Ugu",
    "Scottburgh",
    "uMfolozi Local Municipality",
    "KwaZulu-Natal",
    "King Cetshwayo",
    "KwaMbonambi",
    "uMhlabuyalingana Local Municipality",
    "KwaZulu-Natal",
    "Umkhanyakude",
    "Kwangwanase",
    "uMhlathuze Local Municipality",
    "KwaZulu-Natal",
    "King Cetshwayo",
    "Richards Bay",
    "uMlalazi Local Municipality",
    "KwaZulu-Natal",
    "King Cetshwayo",
    "Eshowe",
    "uMngeni Local Municipality",
    "KwaZulu-Natal",
    "uMgungundlovu",
    "Howick",
    "uMshwathi Local Municipality",
    "KwaZulu-Natal",
    "uMgungundlovu",
    "Wartburg",
    "Umsobomvu Local Municipality",
    "Northern Cape",
    "Pixley ka Seme",
    "Colesberg",
    "uMuziwabantu Local Municipality",
    "KwaZulu-Natal",
    "Ugu",
    "Harding",
    "Umvoti Local Municipality",
    "KwaZulu-Natal",
    "Umzinyathi",
    "Greytown",
    "Umzimkhulu Local Municipality",
    "KwaZulu-Natal",
    "Harry Gwala",
    "Umzimkhulu",
    "Umzimvubu Local Municipality",
    "Eastern Cape",
    "Alfred Nzo",
    "Mount Frere",
    "Umzumbe Local Municipality",
    "KwaZulu-Natal",
    "Ugu",
    "Mtwalume",
    "uPhongolo Local Municipality",
    "KwaZulu-Natal",
    "Zululand",
    "Pongola",
    "Victor Khanye Local Municipality",
    "Mpumalanga",
    "Nkangala",
    "Delmas",
    "Walter Sisulu Local Municipality",
    "Eastern Cape",
    "Joe Gqabi",
    "Burgersdorp",
    "Witzenberg Local Municipality",
    "Western Cape",
    "Cape Winelands",
    "Ceres",
    "Camdeboo Local Municipality",
    "Dr Beyers Naudé Local Municipality",
    "Ikwezi Local Municipality",
    "Baviaans Local Municipality",
    "Nkonkobe Local Municipality",
    "Raymond Mhlaba Local Municipality",
    "Nxuba Local Municipality",
    "Tsolwana Local Municipality",
    "Enoch Mgijima Local Municipality",
    "Inkwanca Local Municipality",
    "Lukhanji Local Municipality",
    "Maletswai Local Municipality",
    "Walter Sisulu Local Municipality",
    "Gariep Local Municipality",
    "Motheo District Municipality",
    "Mangaung Metropolitan Municipality",
    "Xhariep",
    "Thabo Mofutsanyana",
    "Naledi Local Municipality",
    "Mangaung Metropolitan Municipality",
    "Metsweding District Municipality",
    "City of Tshwane Metropolitan Municipality",
    "Nokeng tsa Taemane Local Municipality",
    "Kungwini Local Municipality",
    "Randfontein Local Municipality",
    "Rand West City Local Municipality",
    "Westonaria Local Municipality",
    "Ezinqoleni Local Municipality",
    "Ray Nkonyeni Local Municipality",
    "Hibiscus Coast Local Municipality",
    "Vulamehlo Local Municipality",
    "eThekwini Metropolitan Municipality",
    "Umdoni Local Municipality",
    "Emnambithi/Ladysmith Local Municipality",
    "Alfred Duma Local Municipality",
    "Indaka Local Municipality",
    "Umtshezi Local Municipality",
    "Inkosi Langalibalele Local Municipality",
    "Imbabazane Local Municipality",
    "Big 5 False Bay Local Municipality",
    "Big Five Hlabisa Local Municipality",
    "Hlabisa Local Municipality",
    "Ntambanana Local Municipality",
    "Mthonjaneni",
    "uMfolozi",
    "uMhlathuze",
    "Ingwe Local Municipality",
    "Dr Nkosazana Dlamini-Zuma Local Municipality",
    "Kwa Sani Local Municipality",
    "Bohlabela District Municipality",
    "Ehlanzeni",
    "Mopani",
    "Mutale Local Municipality",
    "Musina",
    "Thulamela",
    "Aganang Local Municipality",
    "Blouberg",
    "Molemole",
    "Polokwane",
    "Mookgopong Local Municipality",
    "Modimolle/Mookgopong Local Municipality",
    "Modimolle Local Municipality",
    "Fetakgomo Local Municipality",
    "Fetakgomo/Greater Tubatse Local Municipality",
    "Greater Tubatse Local Municipality",
    "Umjindi Local Municipality",
    "Mbombela Local Municipality",
    "Kagisano Local Municipality",
    "Kagisano-Molopo Local Municipality",
    "Molopo Local Municipality",
    "Ventersdorp Local Municipality",
    "Ventersdorp/Tlokwe Local Municipality",
    "Tlokwe Local Municipality",
    "Mier Local Municipality",
    "Dawid Kruiper Local Municipality",
    "Khara Hais Local Municipality",
  ];
  // Get Target Element
  getElement(event, valueFor) {
    //console.log(valueFor)
    var element = event.target || event.srcElement || event.currentTarget;

    //this.searchPlaces(element, valueFor);
    this.requestedMap = valueFor;
  }

  mapClicked($event: MouseEvent) {
    /*
     this.markers.push({
     lat: $event.coords.lat,
     lng: $event.coords.lng,
     draggable: true
     });
     */

    this.markerMoved($event);
  }

  markerMoved(e) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: e.coords }, (res, status) => {
      if (status === google.maps.GeocoderStatus.OK && res.length) {
        this.ngZone.run(() => this.setLocation(res[0]));
      }
    });
  }

  setLocation(place) {
    this.latitude = place.geometry.location.lat();
    this.longitude = place.geometry.location.lng();
    this.formatted_address = place.formatted_address;

    // //console.log(this.latitude + '----------' + this.longitude);

    var latlng = { lat: <number>this.latitude, lng: <number>this.longitude };
    this.deliveryDetails[this.requestedMap + "LatLong"] =
      this.latitude + ", " + this.longitude;

    this.geoCodeLatLng(latlng);
  }

  geoCodeAddress(address) {
    this.mapsAPILoader.load().then(() => {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: address }, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          //map.setCenter(results[0].geometry.location);
          ////console.log(results[0].geometry.location);

          this.ngZone.run(() => {
            this.setLocation(results[0]);
          });

          this.latitude = results[0].geometry.location.lat();
          this.longitude = results[0].geometry.location.lng();
          this.zoom = 12;
          // //console.log(this.latitude +', '+this.longitude);
        } else {
          //console.log('Geocode was not successful for the following reason: ' + status);
        }
      });
    });
  }

  geoCodeLatLng(latlng) {
    ////console.log(latlng);
    this.mapsAPILoader.load().then(() => {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: latlng }, (results, status) => {
        if (results[0]) {
          // this.deliveryDetails[this.requestedMap] = results[0].formatted_address;
          this.addMaintenanceOrderForm.patchValue({
            address: results[0].formatted_address,
          });
        }
        ////console.log(this.requestedMap);
        ////console.log(this.deliveryDetails[this.requestedMap]);
      });
    });
  }

  setMapForLocation(address) {
    this.mapsAPILoader.load().then(() => {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: address }, (results, status) => {
        this.deliveryDetails[this.requestedMap + "LatLong"] =
          results[0].geometry.location.lat() +
          ", " +
          results[0].geometry.location.lng();
        ////console.log(this.deliveryDetails[this.requestedMap+'LatLong']);
      });
    });
  }

  // searchPlaces(e, valueFor) {
  //   this.mapsAPILoader.load().then(() => {
  //     let deliveryAddressAutocomplete = new google.maps.places.Autocomplete(e, {
  //       types: ["address"],
  //       componentRestrictions: { country: "in" }
  //     });

  //     ////console.log(deliveryAddressAutocomplete);
  //     //---------------------------load Places Autocomplete-----------
  //     deliveryAddressAutocomplete.addListener("place_changed", () => {
  //       this.ngZone.run(() => {
  //         //get the place result
  //         let place: google.maps.places.PlaceResult = deliveryAddressAutocomplete.getPlace();
  //         //verify result
  //         if (place.geometry === undefined || place.geometry === null) {
  //           return;
  //         }

  //         //set latitude, longitude and zoom
  //         this.formatted_address = place.formatted_address;
  //         this.latitude = place.geometry.location.lat();
  //         this.longitude = place.geometry.location.lng();
  //         this.zoom = 12;

  //         this.deliveryDetails[valueFor] = place.formatted_address;
  //         this.deliveryDetails[valueFor + 'LatLong'] = this.latitude + ', ' + this.longitude;
  //       });
  //     });
  //   });
  // }
  searchPlaces2(valueFor?: any) {
    this.mapsAPILoader.load().then(() => {
      let deliveryAddressAutocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ["address"],
          componentRestrictions: { country: ["na", "ls", "za"] },
        }
      );

      ////console.log(deliveryAddressAutocomplete);
      //---------------------------load Places Autocomplete-----------
      deliveryAddressAutocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          // get the place result
          let place: google.maps.places.PlaceResult =
            deliveryAddressAutocomplete.getPlace();
          console.log(place);
          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          this.addMaintenanceOrderForm.patchValue({
            address: place.formatted_address,
          });
          //set latitude, longitude and zoom
          this.formatted_address = place.formatted_address;
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;

          this.deliveryDetails[valueFor] = place.formatted_address;
          this.deliveryDetails[valueFor + "LatLong"] =
            this.latitude + ", " + this.longitude;
        });
      });
    });
  }

  selectEvent(item) {
    // do something with selected item
  }

  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e) {
    // do something when input is focused
  }

  private setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        //console.log(position);
        //this.zoom = 14;
      });
    }
  }

  dir = undefined;
  options = {
    suppressMarkers: true,
    draggable: true,
    travelMode: "DRIVING",
  };
  /*----------------------------------Google API--------------------------------*/

  initializeMap() {
    this.zoom = 10;
    this.latitude = -25.71753;
    this.longitude = 28.03136;
  }

  ngOnInit() {
    this.initializeMap();
    this.addMaintenanceOrderForm = new FormGroup({
      municipality_center: new FormControl("", [Validators.required]),
      // 'ward': new FormControl('', [Validators.required]),
      site_name: new FormControl("", [Validators.required]),
      client_name: new FormControl("", [Validators.required]),
      project_type: new FormControl("", [Validators.required]),
      description: new FormControl("", [Validators.required]),
      address: new FormControl("", [Validators.required]),
      employee: new FormControl("", [Validators.required]),
      job_type: new FormControl("", [Validators.required]),
      frequency: new FormControl("", [Validators.required]),
      is_active: new FormControl(1),
    });

    this.routePath = "get-employee-names"; // it also update project order
    this._services
      .requestCreator(
        this.addMaintenanceOrderForm.value,
        this.routePath,
        this._services.getToken()
      )
      .subscribe((data: any) => {
        this._services.checkToken(data.status);
        if (data.status == "200") {
          this.employeeList = data.result;
          this.filteredEmployees = this.employeeList;
        }
      });

    // Initially, show all employees
    this.filteredEmployees = this.employees;

    // Filter employees based on initial search query (optional)
    this.filterEmployees();
  }
  isLoader: boolean = false;

  // convenience getter for easy access to form fields
  get f() {
    return this.addMaintenanceOrderForm.controls;
  }

  addOrderProject() {
    this.isFormSubmitted = true;
    console.log(this.addMaintenanceOrderForm.value);
    this.showloader = true;

    //It will not allow to submit form until all input's filled.
    if (this.addMaintenanceOrderForm.status != "VALID") {
      this.showloader = false;
      this.isFormSubmitted = false;
      return false;
    }

    this.routePath = "v2/create-maintenance";
    this._services
      .requestCreator(
        this.addMaintenanceOrderForm.value,
        this.routePath,
        this._services.getToken()
      )
      .subscribe((data: any) => {
        this._services.checkToken(data.status);
        if (data.status == "200") {
          this.showloader = false;
          this.isFormSubmitted = false;
          swal({
            title: "Maintenance",
            text: "Maintenance Added Successfully",
            type: "success",
            showCancelButton: false,
            confirmButtonColor: "rgb(17, 205, 239)",
            cancelButtonColor: "rgb(245, 54, 92)",
            confirmButtonText: "Yes",
          }).then(() => {
            this.resetProjectOrderForm();
          });
        } else {
          this.showloader = false;
          this.isFormSubmitted = false;
        }
      });
  }

  resetProjectOrderForm() {
    this.addMaintenanceOrderForm.reset();
  }

  openEmployeeModal() {
    this.modalService.open(this.employeeModal, { centered: true }); // Open employee modal
  }

  filterEmployees() {
    const query = this.searchQuery.toLowerCase().trim();

    if (!query) {
      this.filteredEmployees = this.employeeList; // Show all employees if query is empty
      return;
    }

    this.filteredEmployees = this.employeeList.filter((employee) => {
      const fullName =
        `${employee.first_name} ${employee.last_name}`.toLowerCase();
      return fullName.includes(query);
    });
  }

  selectEmployee(employee: any) {
    this.selectedEmployee = employee; // Assign the selected employee to the variable
    // Update the form control value with the selected employee's name
    this.addMaintenanceOrderForm.controls["employee"].setValue(
      `${employee.first_name} ${employee.last_name}`
    );
    this.modalService.dismissAll(); // Close the modal

    console.log(this.addMaintenanceOrderForm.value);
  }
}
